<glxy-page [isLoading]="isLoading()">
  <glxy-page-toolbar>
    <glxy-page-nav>
      @if (previousPageUrl) {
        <glxy-page-nav-button
          [previousPageTitle]="previousPageTitle | translate"
          [previousPageUrl]="previousPageUrl"
        ></glxy-page-nav-button>
      }
    </glxy-page-nav>
    <glxy-page-title>{{ 'AI_KNOWLEDGE_BASE' | translate }}</glxy-page-title>
  </glxy-page-toolbar>

  <glxy-page-wrapper widthPreset="narrow">
    <div class="content">
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ 'MANAGE_KNOWLEDGE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <span>{{ 'MANAGE_KNOWLEDGE_DESCRIPTION' | translate }}</span>
            <ai-knowledge-knowledge-list
              [knowledgeSources]="knowledgeSources()"
              [allowRescrapeWebsite]="true"
              (titleClicked)="editKnowledgeSource($event)"
              (removeClicked)="deleteKnowledgeSource($event)"
              (refreshList)="refreshSources()"
              (websiteRescrapeInitiated)="editKnowledgeSource($event, SCRAPED_PAGES_STEP_OPTION)"
              >
            </ai-knowledge-knowledge-list>

            <div class="add-knowledge-source-container">
              <button mat-stroked-button (click)="addNewKnowledgeSource()">
                {{ 'ADD_KNOWLEDGE' | translate }}
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </glxy-page-wrapper>
</glxy-page>
